/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ServiceEnum {
    LEMLIST = 'lemlist',
    SOURCEWHALE = 'sourcewhale',
}
